import { useContext, useEffect, useState, useRef } from "react";
import { requester } from "App";
import { useParams } from "react-router-dom";
import P from "components/P";
import VerticalFlex from "layouts/flex/VerticalFlex";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import Center from "layouts/wrapper/Center";
import Container from "layouts/container/Container";
import { CButton, CFormInput, CInputGroup, CInputGroupText, CFormSelect } from '@coreui/react'
import style from "./VendorStoreInquire.module.css"
import BasicPagination from "routes/front/main/vending/mainPage/layout/process/pagination/BasicPagination";
import { toast } from "react-toastify";

const formatDate = (isoString) => {
    const date = new Date(isoString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${year}.${month}.${day} ${hours}시${minutes}분`;
};

function VendorStoreInquire() {

    const inputs = useRef([]);
    const [isMounted, setMounted] = useState(false);

    const [showInput, setShowInput] = useState(false);
    const [showAnswer, setShowAnswer] = useState({});

    const [inquireList, setInquireList] = useState([]);
    const [storeList, setStoreList] = useState([]);
    const [category, setCategory] = useState("")
    const [selectStore, setSelectStore] = useState("")

    // 페이징 관련 상태
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 5;
    const totalPages = Math.ceil((inquireList?.length || 0) / itemsPerPage);

    // 유효성 검증 함수
    const validInquire = () => {
        const title = inputs.current[0]?.value.trim();
        const content = inputs.current[1]?.value.trim();

        if (!title) {
            toast.error("제목 입력", {
                autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
            });
            inputs.current[0].focus();
            return false;
        }

        if (!content) {
            toast.error("내용 입력", {
                autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
            });
            inputs.current[1].focus();
            return false;
        }

        if (!category) {
            toast.error("카테고리 선택", {
                autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
            });
            return false;
        }

        if (!selectStore) {
            toast.error("매장 선택", {
                autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
            });
            return false;
        }

        return {
            inquireTitle: title,
            inquireContent: content,
            category: category,
            storeName: selectStore,
        };
    };

    const toggleInput = () => {
        setShowInput((prev) => !prev);
    };
    
    const toggleAnswer = (index) => {
        setShowAnswer((prev) => ({
            ...prev,
            [index]: !prev[index],
        }));
    };
    
    const categoryChange = (e) => {
        setCategory(e.target.value);
    }
    
    const storeChange = (e) => {
        setSelectStore(e.target.value);
    }

    useEffect(() => {
        setMounted(true);
    }, [])

    useEffect(() => {
        if (isMounted) {
            requester.vendorInquireList((result) => {
                setInquireList(result?.data || []);
            })
        }
    }, [isMounted]);
    
    useEffect(() => {
        requester.findAllStores((result) => {
            setStoreList(result?.data || []);
        })
    }, [isMounted])

    const inquire = () => {
        if (!validInquire()) {
            return;
        }
        let data = {
            inquireTitle: inputs.current[0].value,
            inquireContent: inputs.current[1].value,
            category: category,
            storeName: selectStore
        }

        requester.vendorRequest(data, (result) => {
            requester.vendorInquireList((result) => {
                setInquireList(result?.data || [])
            })
        })
    }

    const startIndex = (currentPage - 1) * itemsPerPage;
    const displayedList = inquireList?.slice(startIndex, startIndex + itemsPerPage) || [];

    return (
        <Container>
            <Container maxWidth={1200}>
                <VerticalFlex gap={30}>
                    <FlexChild width={"90%"}>
                        <Center width={"100%"} textAlign={"left"}>
                            <P size={40} weight={"bold"}>문의 목록</P>
                        </Center>
                    </FlexChild>
                </VerticalFlex>
                <CButton onClick={toggleInput}>
                    {showInput ? "닫기" : "문의하기"}
                </CButton>

                {showInput && (
                    <div>
                        <CInputGroup>
                            <CInputGroupText>문의 제목</CInputGroupText>
                            <CFormInput
                                placeholder="문의 제목을 입력해주세요"
                                ref={(el) => (inputs.current[0] = el)}
                            />
                        </CInputGroup>
                        <CInputGroup>
                            <CInputGroupText>문의 내용</CInputGroupText>
                            <CFormInput
                                placeholder="문의 내용을 입력해주세요"
                                ref={(el) => (inputs.current[1] = el)}
                            />
                        </CInputGroup>
                        <CInputGroup>
                            <CInputGroupText>카테고리</CInputGroupText>
                            <CFormSelect
                                onChange={categoryChange}
                                value={category}
                            >
                                <option value="">카테고리를 선택하세요</option>
                                <option value="deviceDefect">기기불량</option>
                                <option value="inventoryInquiry">재고문의</option>
                                <option value="etc">기타</option>
                            </CFormSelect>
                        </CInputGroup>
                        <CInputGroup>
                            <CInputGroupText>매장 선택</CInputGroupText>
                            <CFormSelect onChange={storeChange} value={selectStore}>
                                <option value="">매장을 선택하세요</option>
                                {storeList && storeList.map((store) => (
                                    <option key={store.id} value={store.storeName}>
                                        {store.storeName}
                                    </option>
                                ))}
                            </CFormSelect>
                        </CInputGroup>

                        <CButton onClick={inquire}>
                            제출
                        </CButton>
                    </div>
                )}

                <VerticalFlex>
                    <FlexChild>
                        <HorizontalFlex>
                            <FlexChild>
                                <P weight={"bold"} size={"1rem"}>문의 제목</P>
                            </FlexChild>
                            <FlexChild>
                                <P weight={"bold"} size={"1rem"}>문의 내용</P>
                            </FlexChild>
                            <FlexChild>
                                <P weight={"bold"} size={"1rem"}>카테고리</P>
                            </FlexChild>
                            <FlexChild>
                                <P weight={"bold"} size={"1rem"}>답변 확인</P>
                            </FlexChild>
                            <FlexChild>
                                <P weight={"bold"} size={"1rem"}>답변 상태</P>
                            </FlexChild>
                            <FlexChild>
                            </FlexChild>
                        </HorizontalFlex>
                        
                        {(displayedList?.length || 0) > 0 ? (
                            displayedList.map((data, index) => (
                                <div className={style.list} key={index}>
                                    <HorizontalFlex>
                                        <FlexChild>
                                            <p className={style.title}>{data.inquireTitle}</p>
                                        </FlexChild>
                                        <FlexChild>
                                            <p className={style.content}>{data.inquireContent}</p>
                                        </FlexChild>
                                        <FlexChild>
                                            <p>
                                                {data.category === "inventoryInquiry"
                                                    ? "재고문의"
                                                    : data.category === "deviceDefect"
                                                        ? "기기불량"
                                                        : "기타"}
                                            </p>
                                        </FlexChild>
                                        <FlexChild>
                                            {data.inquireType === "Complete" && (
                                                <CButton
                                                    className={style.answerButton}
                                                    onClick={() => toggleAnswer(index)}
                                                >
                                                    {showAnswer[index] ? "답변 숨기기" : "답변 보기"}
                                                </CButton>
                                            )}
                                        </FlexChild>
                                        <FlexChild>
                                            {data.inquireType === "Complete" && (
                                                <p className={style.complete}>답변완료</p>
                                            )}
                                        </FlexChild>
                                        <FlexChild>
                                            <p className={style.date}>{formatDate(data.createDateTime)}</p>
                                        </FlexChild>
                                    </HorizontalFlex>
                                    {data.inquireType === "Complete" && showAnswer[index] && (
                                        <div className={style.answerSection}>
                                            <p className={style.answerContent}>답변내용 : {data.answer}</p>
                                        </div>
                                    )}
                                </div>
                            ))
                        ) : (
                            <Center>
                                <P size={"1rem"} weight={"bold"}>등록된 문의가 없습니다.</P>
                            </Center>
                        )}
                    </FlexChild>
                </VerticalFlex>
                <FlexChild>
                    <BasicPagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={setCurrentPage}
                    />
                </FlexChild>
            </Container>
        </Container>
    );
}
export default VendorStoreInquire;